import * as React from 'react';
import { Grid, Row, Col } from 'react-flexbox-grid';
import Divider from 'material-ui/Divider';

import { InlineGrid, InlineGridField } from '@components/form';

import { EmployeesFormFilesForm } from '@modules/employees/EmployeesFormFilesForm';
import { filesGridColumns } from '@modules/employees/_employeesColumns';

const View: React.SFC<any> = () => (
  <div>
    <Grid fluid={true}>
      <Row>
        <Col md={12}>
          <h4>Osobní soubory</h4>
        </Col>
      </Row>
      <Row>
        <Col md={12}>
          <InlineGridField
            component={InlineGrid}
            name="files"
            Form={EmployeesFormFilesForm}
            columns={filesGridColumns}
            showCheckboxes={true}
            deleting={true}
          />
        </Col>
      </Row>
    </Grid>

    <Divider />
  </div>
);

export const EmployeesFormFiles = View;



// WEBPACK FOOTER //
// ./src/modules/employees/EmployeesFormFiles.tsx